var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBdl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32672)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#E54C40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.24702 4.84703C5.23577 4.76434 5.31339 4.71484 5.35783 4.65859C5.917 4.10533 6.4735 3.54939 7.02733 2.99078C7.01945 4.51853 7.03183 6.04628 7.02114 7.57403C8.1737 6.93841 9.62552 6.91028 10.8101 7.47953C10.809 7.57797 10.809 7.67584 10.809 7.77484C9.86345 7.26634 8.70077 7.20109 7.6922 7.55547C6.53177 7.95484 5.60702 8.93753 5.24533 10.107C5.24702 8.35309 5.24477 6.60034 5.24702 4.84703ZM12.7789 11.4069C12.7437 12.3368 12.3633 13.2202 11.7118 13.8847C11.0993 14.5143 10.2861 14.91 9.4127 15.0035C8.53933 15.0969 7.66076 14.8823 6.92889 14.3966C6.09639 13.8487 5.49452 12.96 5.31002 11.9801C5.1497 11.2038 5.25827 10.3798 5.59183 9.66259C5.97086 8.85597 6.6216 8.20841 7.43008 7.83334C8.48983 7.33384 9.78133 7.37603 10.8073 7.94134C10.8011 8.78172 10.8017 9.62209 10.8079 10.4625C10.6403 10.1154 10.3916 9.80491 10.0626 9.59903C9.41177 9.17884 8.50727 9.19853 7.87895 9.65416C7.18708 10.13 6.87489 11.0739 7.14995 11.8676C7.39577 12.65 8.1737 13.2243 8.99608 13.2153C9.78695 13.235 10.5503 12.7181 10.8332 11.9807C11.0132 11.5627 10.9682 11.1009 10.9721 10.6588C10.9755 8.37784 10.9665 6.09691 10.9676 3.81653C10.9682 3.52966 10.9733 3.24278 10.9564 2.95703C11.5695 3.56116 12.177 4.17259 12.7845 4.78291C12.7721 6.99072 12.7845 9.19853 12.7789 11.4075V11.4069Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32672"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBdl);
export default __webpack_public_path__ + "static/media/bdl.6a03470375ab938f34cd3ce1b34ba67f.svg";
export { ForwardRef as ReactComponent };